module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/5/1-073e7b2fa0da8db768f9f3bfb2f4b3a2.jpg";